import { Layout, ToolsType, ViewType } from '../../models/layoutClass';

let selectedTool = localStorage.getItem('selectedTool') || ToolsType.GRAPHICS;
if (!(selectedTool in ToolsType)) {
  selectedTool = ToolsType.NONE;
}

const initialState: Layout =
{
  view: ViewType.CLASSIC,
  selectedTool,
  liveControlsVisible: true,
  selectedMenu: { isMenu: false, producer: null },
  outputStreams: { studio: true, youtube: false, facebook: false },
  liveStreamRunning: false,
  contentSharing: false,
};


export const LAYOUT_SELECT_VIEW = 'LAYOUT_SELECT_VIEW';
export const LAYOUT_SELECT_TOOL = 'LAYOUT_SELECT_TOOL';
export const LAYOUT_SELECT_MENU = 'LAYOUT_SELECT_MENU';
export const LAYOUT_SET_LAYOUT_INFO = 'LAYOUT_SET_LAYOUT_INFO';
export const LAYOUT_SET_LIVE_CONTROLS = 'LAYOUT_TOGGLE_LIVE_CONTROLS';

export const LAYOUT_SET_STREAMS = 'LAYOUT_SET_STREAMS';
export const LAYOUT_SET_LIVESTREAM_RUNNING = 'LAYOUT_SET_LIVESTREAM_RUNNING';


export const ViewReducer = (state = initialState, action) => {
  switch (action.type) {

    case LAYOUT_SELECT_VIEW: {
      return { ...state, view: action.payload.view };
    }

    case LAYOUT_SELECT_TOOL: {
      // console.log(state, action);
      localStorage.setItem('selectedTool', action.payload);
      return { ...state, selectedTool: action.payload };
    }

    case LAYOUT_SELECT_MENU: {
      // console.log(state, action);
      // if (state.selectedMenu.isMenu === action.payload.isMenu) {
      //   return state;
      // } else {
      return { ...state, selectedMenu: action.payload };
      // }
    }

    case LAYOUT_SET_LAYOUT_INFO: {
      return { ...state, view: action.payload.view, eventName: action.payload.eventName };
    }

    case LAYOUT_SET_LIVE_CONTROLS: {
      return { ...state, liveControlsVisible: action.payload.liveControlsVisible };
    }

    case LAYOUT_SET_STREAMS: {
      return { ...state, outputStreams: action.payload };
    }

    case LAYOUT_SET_LIVESTREAM_RUNNING: {
      return { ...state, liveStreamRunning: action.payload };
    }


    default:
      return state;
  }
};
